import React from "react";
import {useQuery} from "@apollo/client";
import {FormGroup, InputGroup} from "@blueprintjs/core";
import gql from 'graphql-tag';

const GET_TEAM_BY_ID = gql`
    query($teamId: Int!) {
        team(id: $teamId) {
            id
            name
            division {
                id
                name
            }
            displayName: name
        }
    }
`

export const TeamByIdSelector = ({ onTeamIdChange, disabled }) => {

  const [teamId, setTeamId] = React.useState(null);

  const {loading, data} = useQuery(GET_TEAM_BY_ID, {
    variables: {
      teamId
    },
    skip: !teamId
  })

  React.useEffect(() => {
    if (!data?.team) {
      onTeamIdChange(null)
    } else {
      onTeamIdChange(data.team.id)
    }
  }, [onTeamIdChange, data])

  React.useEffect(() => {
    if (disabled) setTeamId('')
  }, [disabled])


  const { team } = data || { team: undefined }


  return (
    <>
      <FormGroup
        disabled={disabled}
        label={'Enter Team ID'}
        helperText={'The numeric ID assigned to your team during registration'}
      >
        <InputGroup
          disabled={disabled}
          type={'number'}
          value={teamId}
          pattern="\d*"
          onChange={e => {
            setTeamId(e.target.value)
          }}
        />
      </FormGroup>


      {teamId && !loading &&
        (
          team ? (
            <h2 style={{margin: 0, padding: 0, marginTop: '25px', textAlign: 'center'}}>{data.team.displayName}</h2>
          ) : (
            <h2 style={{margin: 0, padding: 0, marginTop: '25px', color: 'red', textAlign: 'center'}}>Invalid Team Id</h2>
          )
        )
      }
    </>
  )
}
